/**
 * ReportSubSectionBlocks — nested charts/tables lifted to report-body
 * flex siblings so CSS `order` from template sectionOrder applies.
 */
import React from 'react';
import type { SiteRagReport } from '../../../types/siteRag';
import type { ReportTheme } from '../../../types/reportTheme';
import { ScoreDriverWaterfall } from './charts/ScoreDriverWaterfall';
import { ClimateProfileChart } from './charts/ClimateProfileChart';
import { EditorialSectionShell } from './EditorialSectionShell';
import { reportSectionGapClass } from '../../../lib/reportSpacingTokens';

interface Props {
  report: SiteRagReport;
  theme: ReportTheme;
  isVisible: (sectionId: string) => boolean;
  sectionStyle: (sectionId: string) => React.CSSProperties;
  omitSectionSidebar?: boolean;
  shellPadding?: boolean;
}

export function ReportSubSectionBlocks({
  report,
  theme,
  isVisible,
  sectionStyle,
  omitSectionSidebar = false,
  shellPadding = true,
}: Props): React.ReactElement {
  return (
    <>
      {isVisible('scoreDrivers') && (
        <EditorialSectionShell
          extraClassName={`${reportSectionGapClass(theme.density)} border-b border-slate-100`}
          style={sectionStyle('scoreDrivers')}
          omitSectionSidebar={omitSectionSidebar}
          shellPadding={shellPadding}
          theme={theme}
        >
          <ScoreDriverWaterfall report={report} theme={theme} />
        </EditorialSectionShell>
      )}
    </>
  );
}
